




























import { Component, Vue, Prop } from "vue-property-decorator";
@Component
export default class TierDiscount extends Vue {
  @Prop({
    type: Object,
    required: true,
    default: {
      discountType: "满X元减X元",
      tierDiscounts: [
        {
          condition: 0,
          discount: 0
        }
      ]
    }
  })
  value!: any;
  get conditionUnit() {
    if (
      this.value.discountType === "满X元减X元" ||
      this.value.discountType === "满X元打X折"
    ) {
      return "元";
    }
    return "件";
  }
  get discountUnit() {
    if (
      this.value.discountType === "满X元减X元" ||
      this.value.discountType === "满X件减X元"
    ) {
      return "元";
    }
    return "折";
  }
  addTierDiscount() {
    this.value.tierDiscounts.push({
      condition: 0,
      discount: 0
    });
  }
  removeTierDiscount(index: number) {
    this.value.tierDiscounts.splice(index, 1);
  }
}
